import { useRef } from 'react';

import { MobileRoundId } from './mobileRoundId';
import { Wheel, WheelSectionWrapper } from '../common';
import { MobileResultsHistory } from './mobileResultsHistory';

export const MobileMainTopWrapper = () => {
  const ref = useRef();

  return (
    <WheelSectionWrapper results={MobileResultsHistory}>
      <MobileRoundId />
      <Wheel innerRef={ref} />
    </WheelSectionWrapper>
  );
};
